import { getAccessToken, getIdToken, isAuthenticated, getPunchoutToken } from '@zageno/auth';
import { getBaseUrl } from '@zageno/config';
import { InternalAxiosRequestConfig } from 'axios';
import HttpClient from './httpClient';

export const setupTokens = async (config: InternalAxiosRequestConfig) => {
  // all requests to API GW requires this parameter in header
  config.headers.set('x-z20', true);

  if (await isAuthenticated()) {
    config.headers.set('x-id-token', getIdToken());
    config.headers.set('x-zageno-session', getPunchoutToken());
    config.headers.set('Authorization', `Bearer ${getAccessToken()}`);
  }

  return config;
};

// factory method: initialize HTTP client with access token
export default function createInstance(): HttpClient {
  const client = new HttpClient({
    baseURL: getBaseUrl(),
    // pygeno requires django cookies
    withCredentials: true,
  });

  client.onRequest(setupTokens, null);

  return client;
}
